import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import MainLayout from '../../components/mainlayout';
import Topbar from '../../components/topbar';
import useGetSellers from '../../api/queries/useGetSellers';
import Searchbar from '../../components/searchbar';
import Table from '../../components/table';
import { columns } from './data';
import EditModal from './EditModal';
import useGetAllBalance from '../../api/queries/useGetAllBalance';

const SellersList = () => {
  const viewModalAction = useDisclosure();
  const [sellersData, setSellersData] = useState([]);
  const [selectedSellerId, setSelectedSellerId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const { data, isLoading } = useGetSellers({
    page: 1,
    limit: 10000000,
    sortColumn: 'id',
    sortOrder: 'desc',
    search: searchQuery,
  });

  const balanceQuery = useGetAllBalance();

  useEffect(() => {
    if (!data || !balanceQuery.isSuccess) return;

    const sellers = data?.data || [];

    const balancesMap = balanceQuery.data.reduce((acc, b) => {
      acc[b.seller_id] = b.totalBalance;
      return acc;
    }, {});

    const sellersWithBalance = sellers.map((seller) => ({
      ...seller,
      totalBalance: balancesMap[seller._id] || 0,
    }));

    // Filter out sellers with employee or owner role
    const filteredSellers = sellersWithBalance.filter(seller => {
      const role = seller?.authUser?.role;
      return role !== 'employee' && role !== 'owner';
    });

    setSellersData(filteredSellers);
  }, [data, balanceQuery.isSuccess, balanceQuery.data]);

  return (
    <MainLayout>
      <Box>
        <Box h={'100vh'} paddingBottom={20}>
          <Topbar title={'Sellers'} />
          <Flex bg={'#f8fbff'} padding={4} height={'100%'} gap={2}>
            <Flex flex={1} direction={'column'} padding={4} gap={4}>
              <Box maxW={'320px'} mb={'8px'}>
                <Searchbar onChange={setSearchQuery} />
              </Box>
              <Box height="1px" width="100%" bg="#8A8F9333" mx="auto" />
              <Box minW={'100%'} w={'1px'} overflowX={'auto'}>
                {isLoading ? (
                  <h2>Loading sellers</h2>
                ) : (
                  <Table
                    data={sellersData}
                    columns={columns({
                      onEditOpen: (row) => {
                        setSelectedSellerId(row._id);
                        viewModalAction.onOpen();
                      },
                    })}
                    rowsPerPage={10}
                    defaultSortColumnId={1}
                    defaultSortAsc={false}
                  />
                )}
              </Box>
            </Flex>
          </Flex>
        </Box>
        {selectedSellerId && (
          <EditModal
            isOpen={viewModalAction.isOpen}
            onClose={viewModalAction.onClose}
            sellerId={selectedSellerId}
          />
        )}
      </Box>
    </MainLayout>
  );
};
export default SellersList;
